import React, { useState, useEffect } from "react";
import './Hero.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../Components/Navbar/Navbar.js';
import heroVideo from "../assets/video.mp4";

const HeroSection = () => {
  const [navbarBg, setNavbarBg] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setNavbarBg(window.scrollY > 50);
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const titleParallaxStyle = {
    transform: `translateX(-${scrollPosition * 0.3}px)`,
    transition: 'transform 0.3s ease-out',
    opacity: 1 - scrollPosition / 500,
    fontFamily: 'Playfair Display, Montserrat, sans-serif', // Use a cursive font
    fontStyle: 'italic', // Make the text italic
  };

  const subtitleParallaxStyle = {
    transform: `translateX(${scrollPosition * 0.3}px)`,
    transition: 'transform 0.3s ease-out',
    opacity: 1 - scrollPosition / 500,
    fontFamily: 'Playfair Display, Montserrat, sans-serif', // Use a cursive font
    fontStyle: 'italic', // Make the text italic
  };

  return (
    <div className="relative bg-cover bg-center h-screen">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, rgba(6, 34, 36, 0.7), transparent)',
          transition: 'background 1s ease-in-out',
        }}
      ></div>

      {/* Content */}
      <div className="relative h-full flex flex-col">
        <Navbar navbarBg={navbarBg} />

        <main className="flex flex-col items-center justify-center text-center text-white h-full bg-black bg-opacity-30 p-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          <h1
            className="text-3xl md:text-6xl font-extrabold mb-2 drop-shadow-lg"
            style={titleParallaxStyle}
          >
            Life is either a daring adventure or nothing at all
          </h1>
          <h2
            className="text-2xl md:text-4xl font-semibold mb-8 drop-shadow-lg"
            style={subtitleParallaxStyle}
          >
            Creating memories
          </h2>
        </main>

        {/* Gradient Overlay at Bottom */}
        <div
          className="absolute bottom-0 w-full"
          style={{
            height: '100px',
            background: 'linear-gradient(to bottom, transparent, #062224)',
          }}
        ></div>
      </div>
    </div>
  );
};

export default HeroSection;
